import {Input} from "../Form/types";
import {createTextInput} from "../Form/Input";

export const InputSalaryExpectations = (el: HTMLElement|null) => {
    return el
        ? createTextInput( el as HTMLInputElement, ( input: Input, value: string ): void => {
            // no validation here.
        } )
        : null;
}
